import React from 'react';
import routes from '../constants/routes.json';
import { AnyType, Project, RunningProject } from '~/types';
import { DefaultRunningAnyTile } from './defaultUIComponents';
import { useRunningAnys } from '~/api/JobApi';
import { useEmployeeId } from '~/state/auth';
import { isRunningProject } from '~/utils/runningAny';
import { useStartProject } from '~/api/RunningProjectApi';
import { useNavigate } from 'react-router';

type RunningProjectTileProps = {
  project: Project;
  isStartable?: boolean;
};

const RunningProjectTile: React.FC<RunningProjectTileProps> = ({
  project,
  isStartable,
}) => {
  const navigate = useNavigate();
  const employeeId = useEmployeeId();

  const { data: runningProject } = useRunningAnys({
    employeeId,
    select: (ra) =>
      ra.find(
        (rp) => isRunningProject(rp) && Number(rp.project.id) === project.id,
      ) as RunningProject | undefined,
  });

  const projectRoute = routes.PROJECT.replace(':id', String(project.id));

  const onSuccess = () => {
    return navigate(projectRoute);
  };

  const { mutate: startProject } = useStartProject({ onSuccess });

  const runProjectOnClick = () => {
    if (runningProject?.status === 'R') {
      return void navigate(projectRoute);
    }
    // Paused or not started — start_project endpoint handles both
    startProject({ projectId: project.id });
  };

  return (
    <DefaultRunningAnyTile
      anyType={AnyType.project}
      name={project.name}
      description=""
      runRunningAny={runProjectOnClick}
      isStartable={isStartable}
    />
  );
};

export default RunningProjectTile;
